import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mt-4 text-left space-y-4" };
const _hoisted_2 = {
    key: 0,
    class: "text-sm text-gray-500 text-center py-8"
};
const _hoisted_3 = {
    key: 1,
    class: "text-sm text-red-600 text-center"
};
const _hoisted_4 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2 text-sm" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "font-medium text-gray-500" }, "From", -1);
const _hoisted_6 = { class: "mt-1 text-gray-900" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("dt", { class: "font-medium text-gray-500" }, "To", -1);
const _hoisted_8 = { class: "mt-1 text-gray-900" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("dt", { class: "font-medium text-gray-500" }, "Letter type", -1);
const _hoisted_10 = { class: "mt-1 text-gray-900 capitalize" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "font-medium text-gray-500" }, "Subject", -1);
const _hoisted_12 = { class: "mt-1 text-gray-900" };
const _hoisted_13 = {
    key: 0,
    class: "rounded-md bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("p", { class: "font-medium" }, "This letter was sent previously", -1);
const _hoisted_15 = { class: "mt-1" };
const _hoisted_16 = { class: "border border-gray-200 rounded-md max-h-96 overflow-y-auto bg-white" };
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["disabled"];
const _hoisted_19 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MailIcon = _resolveComponent("MailIcon");
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    return (_openBlock(), _createBlock(_component_ModalWindow, {
        size: "4xl",
        onClose: _ctx.emitClose
    }, {
        icon: _withCtx(() => [
            _createVNode(_component_MailIcon, {
                class: "h-6 w-6 text-green-600",
                "aria-hidden": "true"
            })
        ]),
        title: _withCtx(() => [
            _createTextVNode("Send leaver letter")
        ]),
        subtitle: _withCtx(() => [
            _createTextVNode("\n      Review the letter below, then confirm to email the employee and retain a\n      PDF on this request.\n    ")
        ]),
        main: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.loadingPreview)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "\n          Loading letter preview…\n        "))
                    : (_ctx.previewError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.previewError), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("dl", _hoisted_4, [
                                _createElementVNode("div", null, [
                                    _hoisted_5,
                                    _createTextVNode(),
                                    _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.fromEmail), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _hoisted_7,
                                    _createTextVNode(),
                                    _createElementVNode("dd", _hoisted_8, _toDisplayString(_ctx.recipientEmail || 'No employee email on this request'), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createElementVNode("dd", _hoisted_10, _toDisplayString(_ctx.letterType), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _hoisted_11,
                                    _createTextVNode(),
                                    _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.subject || '—'), 1)
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.previouslySent)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _hoisted_14,
                                    _createTextVNode(),
                                    _createElementVNode("p", _hoisted_15, [
                                        _createTextVNode("\n              Sent to " + _toDisplayString(_ctx.previouslySent.sentTo || 'unknown') + " ", 1),
                                        (_ctx.previouslySent.sentAt)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode("\n                on " + _toDisplayString(_ctx.formatSentAt(_ctx.previouslySent.sentAt)), 1)
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(),
                                        (_ctx.previouslySent.sentByEmail)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("\n                by " + _toDisplayString(_ctx.previouslySent.sentByEmail), 1)
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        _createTextVNode("\n              . Sending again will email another copy and append a dated PDF for\n              P-file download.\n            ")
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", {
                                    class: "p-4 prose prose-sm max-w-none",
                                    innerHTML: _ctx.sanitizedHtml
                                }, null, 8, _hoisted_17)
                            ])
                        ], 64))
            ])
        ]),
        footer: _withCtx(() => [
            _createElementVNode("button", {
                type: "button",
                class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500",
                disabled: !_ctx.canSend || _ctx.sending,
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleSend && _ctx.handleSend(...args)))
            }, _toDisplayString(_ctx.sending
                ? 'Sending…'
                : _ctx.previouslySent
                    ? 'Resend letter'
                    : 'Send letter'), 9, _hoisted_18),
            _createTextVNode(),
            _createElementVNode("button", {
                type: "button",
                class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500",
                disabled: _ctx.sending,
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.emitClose && _ctx.emitClose(...args)))
            }, "\n        Cancel\n      ", 8, _hoisted_19)
        ]),
        _: 1
    }, 8, ["onClose"]));
}
